module.exports = __webpack_public_path__ + "img/Group 1353@2x.1dfd39d3.png";